module.exports = __webpack_public_path__ + "assets/4204426e26e79072d66159aeab245c81.png";